import React from "react";
import RsRenamable from "components/Renamable/components/RsRenamable";
/**
 * TODO: This component is draft and must be improved in order to leverage validation functionality from
 * Input component instead of internal validation of RenamableCore
 */
const RenamableInput = ({ onChange, value, entityType, ...props }) => {
    return React.createElement(RsRenamable, { onRename: onChange, entityType: entityType, text: value, ...props });
};
export default RenamableInput;
